import api from "../api";

export const getQueries = (params) =>
  api.get("/query", { params });

export const getQueryDetail = (id) =>
  api.get(`/query/${id}/detail`);

export const completeQuery = (id) =>
  api.post(`/query/${id}/complete`);
